import Mss from './Mss'

export default Mss
